import { useTranslation } from 'next-i18next';
import { BASE_PATH } from '@config/index';
const DefaultSeoConfig = () => {
  const {
    t
  } = useTranslation('seo');
  return {
    title: '',
    titleTemplate: `%s`,
    defaultTitle: t('defaultTitle'),
    description: t('description'),
    additionalMetaTags: [{
      name: 'msapplication-TileColor',
      content: '#ffffff'
    }, {
      name: 'msapplication-TileImage',
      content: '/pwa/ms-icon-144x144.png'
    }, {
      name: 'theme-color',
      content: '#ffffff'
    }, {
      name: 'google-site-verification',
      content: 'M_IKEZBKcZHr9B3rcwSebFDRWvvswiXdrAGJ5Mq1rY4'
    }, {
      name: 'facebook-domain-verification',
      content: '53cgwe9jlyetgm80m1u23x47lyzgkn'
    }],
    additionalLinkTags: [{
      rel: 'preload',
      href: `${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff2`,
      as: 'font',
      type: 'font/woff2',
      crossOrigin: ''
    }, {
      rel: 'preload',
      href: `${BASE_PATH}/fonts/uniform_pro_condensed_medium/uniformprocon-med-webfont.woff2`,
      as: 'font',
      type: 'font/woff2',
      crossOrigin: ''
    }, {
      rel: 'preload',
      href: `${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff2`,
      as: 'font',
      type: 'font/woff2',
      crossOrigin: ''
    }, {
      rel: 'preload',
      href: `${BASE_PATH}/fonts/noe_display_bold/NoeDisplay-Bold.woff2`,
      as: 'font',
      type: 'font/woff2',
      crossOrigin: ''
    }, {
      rel: 'apple-touch-icon',
      sizes: '57x57',
      href: `${BASE_PATH}/pwa/apple-icon-57x57.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '60x60',
      href: `${BASE_PATH}/pwa/apple-icon-60x60.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '72x72',
      href: `${BASE_PATH}/pwa/apple-icon-72x72.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '76x76',
      href: `${BASE_PATH}/pwa/apple-icon-76x76.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '114x114',
      href: `${BASE_PATH}/pwa/apple-icon-114x114.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '120x120',
      href: `${BASE_PATH}/pwa/apple-icon-120x120.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '144x144',
      href: `${BASE_PATH}/pwa/apple-icon-144x144.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: `${BASE_PATH}/pwa/apple-icon-152x152.png`
    }, {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: `${BASE_PATH}/pwa/apple-icon-180x180.png`
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '192x192',
      href: `${BASE_PATH}/pwa/android-icon-192x192.png`
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: `${BASE_PATH}/pwa/favicon-32x32.png`
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '96x96',
      href: `${BASE_PATH}/pwa/favicon-96x96.png`
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: `${BASE_PATH}/pwa/favicon-16x16.png`
    }]
  };
};
export default DefaultSeoConfig;